export const API_BASE = 'http://localhost:1337/';

export enum RequestStatus {
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected'
}